export const FILE_TYPE_PARAMS = {
  CSV: 'CSV',
  EXCEL: 'EXCEL',
};
